import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import useFormValidator from 'useFormValidator';
import CountdownComponent from 'modules/common/components/CountdownComponent';
import _ from 'lodash';
import { ModalContext } from 'App';
import PinInput from 'modules/common/components/PinInput';
import { getJson } from 'session';
import * as actions from '../../../actions';
import * as c from '../../../constants';

function EmailSetup({ email2fa, goBack, history,
  resendOtp,
  isLoading,
  resending,
  mfaLogin,
  token,
  profile,
  selectedMfa,
  updateMfaType
}) {

  const authProfile = getJson('profile') || {};
  const [rand, setRand] = useState(_.random(1, 1000));

  const [formData, setFormData] = useState({
    email: authProfile.email
  });

  const commonValidation = {
    email: 'required',
  }

  const validateForm = useFormValidator(
    formData,
    commonValidation,
  );

  useEffect(() => {
    validateForm.onSetObjectRules(commonValidation)
  }, []);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const [showOTP, setShowOTP] = useState(false);

  const setModal = useContext(ModalContext);

  const handleGoBack = (e) => {
    e.preventDefault();
    goBack(0);
  };

  const handleOnChange = (e) => {
    e.preventDefault();
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnchangePin = otp => {
    setFormData({
      ...formData,
      otp
    });
  };

  const secretEmail = val => {
    return [...val].map((item, i) => (i > 1 && i < 9 ? "*" : item));
  };

  const handleNext = () => {
    const args = {
      email: formData.email,
      token,
    };
    email2fa(args, () => {
      setShowOTP(true);
    });
  };

  const handleOTP = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
      secret: formData.otp,
      mfa_type: 'email_otp',
      token
    };
    mfaLogin(args, () => {
      if (selectedMfa === 1) {
        const mfaPayload = {
          token,
          preferred_mfa: 'email_otp',
          email: profile.email
        }
        updateMfaType(mfaPayload, () => {
        });
      }
      setModal({ isOpen: false });
      history.push('/');
    });
  };

  const handleResendOtp = e => {
    e.preventDefault();
    const args = {
      email: formData.email,
      token
    };
    resendOtp(args, () => {
      setRand(_.random(1, 1000));
      setShowOTP(true);
    });
  };

  return (
    <>
      {!showOTP && (
        <>
          <div className="mfa-modal">
            {!profile.is_email_2fa_enabled && (
              <div className='cms-text-primary cms-outline-primary font-weight-bold'>
                To continue setting up Email Authentication for your account, please confirm your email address below:
              </div>
            )}
            {profile.is_email_2fa_enabled && (
              <div className='cms-text-primary cms-outline-primary font-weight-bold' style={{ fontSize: '14px' }}>
                To continue your login to your account, please confirm your email address below:
              </div>
            )}

            <div className="form-group mt-2">
              <label className="form-label pb-1">
                Email Address {validateForm.renderMessage('email')}
              </label>
              <input
                type="email"
                placeholder="Email Address"
                onChange={handleOnChange}
                name="email"
                value={_.get(formData, 'email') || ''}
                id="loginUsername"
                disabled
                className="form-control form-control-lg"
                style={{ border: '1px solid #D3D3D3', borderRadius: '8px' }} // smart-city
              />
            </div>
            <div className="w-100 d-flex ml-auto justify-content-end">
              <button
                type="button"
                onClick={handleGoBack}
                className="mt-3 btn btn-change cms-text-primary"
              >
                <span className="font-weight-bold">
                  Change Authentication Method
                </span>
              </button>
            </div>
          </div>
          <hr className='below-hr' />
          <div className="mfa-modal">
            <div className="d-flex justify-content-center">
              <button
                type="button"
                onClick={handleNext}
                disabled={formData.email === ''}
                className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary"
              >
                <span className="font-weight-bold">
                  Continue
                </span>
              </button>
            </div>
          </div>
        </>
      )}
      {showOTP && (
        <form className="mfa-modal" onSubmit={handleOTP}>
          <div className="form-header p-3">
            <span
              className="text-color text-center"
            >
              We sent your One Time Password (OTP) to{" "}
            </span>
            <span className="email-text">
              {_.get(formData, "email")
                ? secretEmail(
                  _.get(formData, "email")
                ) : secretEmail(_.get(formData, 'email'))}
            </span>
          </div>
          <div className="col-12">
            <PinInput onChange={handleOnchangePin} />
          </div>
          <div className="col-12 mt-2 text-center">
            <CountdownComponent key={`countdown-${rand}`} />
          </div>
          <div className="d-flex flex-column flex-md-row flex-lg-row flex-xl-row text-center">
            <div className="col-12 col-md-6">
              <button
                onClick={handleResendOtp}
                type="submit"
                className="btn btn-primary mt-4 btn-block cms-bg-color-primary"
              >
                {resending && <i className="fa fa-spin fa-spinner" />}{" "}
                <span className='mr-2 label-small'>Resend OTP</span>
              </button>
            </div>
            <div className="col-12 col-md-6">
              <button
                type="submit"
                className="btn btn-primary mt-4 btn-block cms-bg-color-primary"
                disabled={isLoading || _.isEmpty(formData.otp)}
              >
                {isLoading && <i className="fa fa-spin fa-spinner" />}{" "}
                Submit
              </button>
            </div>
          </div>
          <div className="col-12 text-center mt-2">
            <div className="flex-column">
              <span className='title mr-1'> or </span> {""}
              <button
                type="button"
                onClick={handleGoBack}
                className="btn btn-change cms-text-primary"
              >
                <span className="font-weight-bold">
                  Change Authentication Method
                </span>
              </button>
            </div>
          </div>
        </form>
      )}
    </>
  );
}

EmailSetup.defaultProps = {
  selectedMfa: 0
};

EmailSetup.propTypes = {
  profile: PropTypes.instanceOf(Object).isRequired,
  goBack: PropTypes.instanceOf(Function).isRequired,
  email2fa: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  resendOtp: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  resending: PropTypes.bool.isRequired,
  mfaLogin: PropTypes.instanceOf(Function).isRequired,
  token: PropTypes.string.isRequired,
  selectedMfa: PropTypes.number,
  updateMfaType: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: _.get(api, "loading", []).indexOf(c.ENABLE_2FA) > -1,
  resending: _.get(api, "loading", []).indexOf(c.RESEND_OTP) > -1,
  token: sessionStorage.getItem('temporaryToken') || '',
});


const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    {
      ...actions,
    },
  ),
]);

export default enhance(EmailSetup);